import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SchemaPointRequest } from 'src/app/models/affiliate.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AffiliateService } from 'src/app/services/affiliate.service';

@Component({
  selector: 'app-modal-schema-point',
  templateUrl: './modal-schema-point.component.html',
  styleUrls: ['./modal-schema-point.component.scss', '../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalSchemaPointComponent implements OnInit {
  newSchema: SchemaPointRequest = new SchemaPointRequest();
  positionSelected = null;
  loading = false;
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private toastService: ToastrService,
    private affiliateService: AffiliateService
  ) {

  }

  ngOnInit(): void {

  }

  create() {
    this.affiliateService.addSchemaPoints(this.newSchema).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Esquema de puntos agregado con éxito");
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
}
